<template>
    <div  class="container_view">
        <v-card class="content_card" elevation="10" variant="flat">  
            <div>
                <header>
                    <v-card-title> Estadistica </v-card-title>
                    <v-divider class="mx-3"></v-divider>
                </header>
            </div> 
            <div class="container_table">
                <div class="btn-graficas">
                    <v-card
                        class="mx-auto"
                        max-width="344"
                        hover
                        @click="redireccion('gestiones')"
                    >
                        <v-card-item>
                            <v-card-title>
                                Gestiones
                            </v-card-title>                            
                        </v-card-item>

                        <v-card-text>
                            <img src="@/assets/images/gestion-de-proyectos.png" alt="">                            
                        </v-card-text>
                    </v-card>
                </div>
                <div class="btn-graficas">
                    <v-card
                        class="mx-auto"
                        max-width="344"
                        hover
                        @click="redireccion('cobranza')"
                    >
                        <v-card-item>
                            <v-card-title>
                                Cobranza
                            </v-card-title>                           
                        </v-card-item>

                        <v-card-text>
                            <img src="@/assets/images/cobranza.png" alt="">
                        </v-card-text>
                    </v-card>
                </div>
                <div class="btn-graficas" v-if="typeUser === 'Administrador' || typeUser === 'Supervisor'">
                    <v-card
                        class="mx-auto"
                        max-width="344"
                        hover
                        @click="redireccion('metas')"
                    >
                        <v-card-item>
                            <v-card-title>
                                Metas
                            </v-card-title>
                        </v-card-item>

                        <v-card-text>
                            <img src="@/assets/images/metas.png" alt="">
                        </v-card-text>
                    </v-card>
                </div>

                
            </div>            
        </v-card>
    </div>
    
</template>


<script>
    import { EncryptService } from '@/services/EncryptService';
    export default {
        name: 'GraficasComponent',
        components: {
           
        },
        data() {
            return {
                typeUser: '',
            };
        },
        async created () {
            const ENC_TIPO = localStorage.getItem('TIPO')
            const TIPO = await EncryptService.decrypt(ENC_TIPO)
            this.typeUser = TIPO
        },
        methods: {
            redireccion(tipo){
                switch (tipo) {
                    case 'cobranza':
                        this.$router.push({ path: '/SGCCV/estadistica-cobranza' });
                    break;

                    case 'gestiones':
                        this.$router.push({ path: '/SGCCV/estadistica-gestiones' });
                    break;
                    
                    case 'metas':
                        this.$router.push({ path: '/SGCCV/estadistica-metas' });
                    break;
                
                    default:
                        break;
                }
                
            }
        },
    };
   
</script>

<style>
    .content_accion {
        padding-bottom: 10px !important;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
    }

    .dates{
        float: left;
        margin: 1vh;        
    }

    .content_table {
        overflow: auto;
        height: 52vh;
              
    }

    .content_main {
        padding-top: 20px;
    }

    .card{       
        max-width: 180vh;
        max-height: 75vh;
        margin: 8vh;  
    }

    .btn-searhc{
        float: left;
        margin-top: 3vh;
        margin-right: 3vh;
    }

    .btn-graficas{
        float: left;
        margin: 5vh;
        
    }

   

</style>